export default "/images/create-new-icon.svg?623d13be6965cff70a8236147ff0a92b";